"use client";

import { useEffect } from "react";

export default function ContactHydrator() {
  useEffect(() => {
    const links = document.querySelectorAll(".protected-link");
    
    links.forEach(link => {
      const type = link.getAttribute("data-contact-type");
      const encVal = link.getAttribute("data-enc-val");
      const encText = link.getAttribute("data-enc-text");

      if (type && encVal && encText) {
        // decode them back to normal
        const decodedVal = atob(encVal);
        const decodedText = atob(encText);
        
        // restore the original functionality
        link.setAttribute("href", `${type}:${decodedVal}`);
        link.innerHTML = decodedText;
        link.classList.remove("protected-link"); 
      }
    });
  }, []);

  return null;
}